export const totalItemsColumnHeaderId = 'totalItems';
export const totalWeightColumnHeaderId = 'totalWeight';
export const totalAmountColumnHeaderId = 'totalAmount';
